import React from "react";
import styles from "./style.module.scss";
import CaretDown24 from "../../../../../../../../assets/svg/icons/common/CaretDown24";
import CheckGreenCircleIcon from "../../../../../../../../assets/svg/icons/common/check-green-circle";
import CrossRedCircleIcon from "../../../../../../../../assets/svg/icons/common/cross-red-circle";
import useDomainStore from "../../../../../../../../stores/domain";

const ReviewHeader = ({ title, isOpen, onToggle, onEdit, complete = true }) => {
  const { isKurvDomain } = useDomainStore();
  
  return (
    <div className={`${styles.header} ${isKurvDomain ? styles.kurv_theme : ""}`} onClick={onToggle}>
      <div className={styles.header_left}>
        <CaretDown24 data-open={String(isOpen)} />
        <h6 className={styles.title}>{title}</h6>
      </div>
      {onEdit && (
        <div className={styles.headerRight}>
          <button
            type="button"
            className={styles.editButton}
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
          >
            Edit
          </button>
          {complete ? (
            <CheckGreenCircleIcon width="20" height="20" />
          ) : (
            <CrossRedCircleIcon size={20} />
          )}
        </div>
      )}
    </div>
  );
};

export default ReviewHeader;
